import { useParams } from "react-router-dom"
import { useEffect } from "react"

const NumberContainer = () => {
  const searchParams = useParams()
  const { id } = searchParams

  useEffect(() => {
    if (id === "manejebem") {
      window.open(encodeURI(`https://wa.me/554796948569`), "_self")
    } else if (id === "amazoniajordao") {
      window.open(encodeURI(`https://wa.me/554796948569`), "_self")
    } else if (id === "coopatec") {
      window.open(encodeURI(`https://wa.me/554796948569`), "_self")
    } else {
      window.open("https://manejebem.com/", "_self")
    }
  }, [id])

  return <div>Carregando!</div>
}

export default NumberContainer
